import React from "react";
import { Link } from "gatsby";
import bannerBg from "../../assets/images/home/banner-bg.png";
import bannerBgWebp from "../../assets/images/home/banner-bg.webp";

const Banner = ({
  heading,
  subheading,
  link = "",
  linkText,
  animationClass,
  isIndexPage,
  isGithubButton = false,
  githubLink = "",
  customClass = "",
  caseStudyDetailsPage,
  isAnotherPage = false,
  isButton = false,
  isSearch = false,
  sameDomainWithAnotherPage = false,
  value = "",
  onChangeSearch,
  // isShowCategories = false,
  // categories,
  // onCategorySelect,
  // selectedCategory,
}) => {

  const handleLinkClick = e => {
    e.preventDefault();
    if (link.startsWith("#")) {
      const target = document.querySelector(link);
      if (target) {
        target.scrollIntoView({ behavior: "smooth" });
      }
    } else if (link.startsWith("https://") || isAnotherPage) {
      window.open(link, "_blank");
    }
  };
  return (
    <div className="2xl:pt-[120px] sm:pt-24 pt-12 2xl:pb-[120px] sm:pb-24 pb-12 relative lg:px-7 px-5 overflow-hidden">
      <div className="container max-w-7xl mx-auto relative">
        <div className="text-center max-w-[1060px] mx-auto">
          <h1
            className={`xl:text-[52px] sm:text-[45px] text-3xl font-semibold text-gray-900 leading-tight pb-px ${caseStudyDetailsPage ? "mb-0" : "sm:mb-8 mb-4"
              }`}
          >
            {heading}
          </h1>
          <p
            className={`lg:text-xl sm:text-lg text-base text-gray-700 font-light !leading-[1.7] max-w-[620px] mx-auto ${customClass} ${caseStudyDetailsPage ? "hidden" : ""
              }`}
          >
            {subheading}
          </p>
          {isSearch && (
            <>
              <div className="sm:mt-8 mt-7 max-w-[540px] mx-auto relative">
                <input
                  value={value}
                  onChange={onChangeSearch}
                  type="search"
                  placeholder="Search..."
                  className="w-full sm:py-2.5 py-2 pl-3 sm:pr-9 pr-8 bg-white border border-gray-500 focus:outline-none text-gray-600 placeholder:text-gray-600 rounded-md placeholder:text-lg text-lg"
                />
                <div className="absolute sm:right-3 right-2.5 top-3.5 m-auto cursor-pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" className="sm:w-[22px] w-5 sm:h-[22px] h-5">
                    <path
                      fill="#6c757d"
                      d="m229.66 218.34l-50.07-50.06a88.11 88.11 0 1 0-11.31 11.31l50.06 50.07a8 8 0 0 0 11.32-11.32M40 112a72 72 0 1 1 72 72a72.08 72.08 0 0 1-72-72"
                    />
                  </svg>
                </div>
              </div>
              {/* <div>
                {isShowCategories && (
                  <div className="flex flex-wrap items-center justify-center gap-3  max-w-[540px] mx-auto sm:mt-8 mt-7">
                    <button
                      onClick={() => { onCategorySelect('all'); setSelectedCategory('All') }}
                      className={`border rounded-md py-1 px-4 text-sm font-medium cursor-pointer ${selectedCategory === 'All'
                        ? 'bg-primary text-white border-primary'
                        : 'bg-white text-gray-600 border-gray-500 hover:bg-primary hover:text-white hover:border-primary'
                        }`}
                    >
                      All
                    </button>
                    {categories.map(category => (
                      <button
                        key={category}
                        onClick={() => {
                          if (selectedCategory === category) {
                            onCategorySelect(null);
                          } else {
                            onCategorySelect(category);
                          }
                        }}
                        className={`border rounded-md py-1 px-4 text-sm font-medium cursor-pointer ${selectedCategory === category
                          ? 'bg-primary text-white border-primary'
                          : 'bg-white text-gray-600 border-gray-500 hover:bg-primary hover:text-white hover:border-primary'
                          }`}
                      >
                        {category}
                      </button>
                    ))}
                  </div>
                )}
              </div> */}
            </>
          )}
          <div className="flex justify-center items-center sm:gap-4 gap-2.5">
            {isGithubButton && (
              <>
                <a
                  href={githubLink}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-2 lg:text-xl text-lg font-medium text-gray-900  lg:mt-[60px] sm:mt-12 mt-7"
                >
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.9984 0C5.82075 0 0 5.96773 0 13.3295C0 19.2175 3.7245 24.2128 8.892 25.9769C9.542 26.0997 9.77925 25.6881 9.77925 25.3346C9.77925 25.0177 9.76787 24.1796 9.76138 23.0677C6.14575 23.8726 5.382 21.2804 5.382 21.2804C4.79213 19.7403 3.939 19.3304 3.939 19.3304C2.75763 18.5039 4.02675 18.5205 4.02675 18.5205C5.33162 18.6151 6.01737 19.8946 6.01737 19.8946C7.17763 21.9309 9.061 21.3434 9.802 21.0016C9.919 20.1403 10.2554 19.5528 10.6275 19.2192C7.7415 18.8823 4.706 17.7389 4.706 12.6325C4.706 11.177 5.213 9.98715 6.045 9.05449C5.91013 8.7176 5.46488 7.36175 6.17175 5.52795C6.17175 5.52795 7.26375 5.16949 9.74675 6.89376C10.7835 6.59836 11.895 6.45066 13.0016 6.44568C14.105 6.45232 15.2181 6.59836 16.2565 6.89542C18.7379 5.17115 19.8282 5.52961 19.8282 5.52961C20.5367 7.36507 20.0915 8.71926 19.9583 9.05615C20.7919 9.98881 21.294 11.1787 21.294 12.6341C21.294 17.7538 18.2552 18.8807 15.3595 19.2109C15.8259 19.6225 16.2419 20.4357 16.2419 21.6787C16.2419 23.461 16.2256 24.8982 16.2256 25.3346C16.2256 25.6914 16.4596 26.1063 17.1194 25.9752C22.2787 24.2095 26 19.2159 26 13.3295C26 5.96773 20.1793 0 12.9984 0Z"
                      fill="#212529"
                    />
                  </svg>
                  GitHub
                </a>
                <span className="text-black lg:mt-[60px] sm:mt-12 mt-7">|</span>
              </>
            )}
            {isButton ? (
              <button
                className={`cursor-pointer w-fit flex items-center gap-5 lg:text-xl text-lg font-medium text-gray-900  lg:mt-[60px] sm:mt-12 mt-7 ${isIndexPage ? "hidden" : ""
                  }`}
                onClick={handleLinkClick}
              >
                {linkText}
                <svg
                  className={`${animationClass}`}
                  width="13"
                  height="30"
                  viewBox="0 0 13 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.18502 19.7224L7.18594 19.7215L12.2182 14.7758C12.5952 14.4053 12.5938 13.806 12.2149 13.4372C11.8361 13.0684 11.2234 13.0698 10.8463 13.4404L7.46774 16.7609L7.46774 0.946514C7.46774 0.423754 7.03448 0 6.5 0C5.96552 0 5.53226 0.423754 5.53226 0.946514L5.53226 16.7609L2.15368 13.4404C1.77664 13.0699 1.16392 13.0685 0.785093 13.4372C0.406174 13.806 0.404867 14.4054 0.781803 14.7758L5.81406 19.7216L5.81498 19.7224C6.19327 20.0931 6.80798 20.0919 7.18502 19.7224Z"
                    fill="#212529"
                  />
                </svg>
              </button>
            ) : sameDomainWithAnotherPage ? (
              <a
                href={link}
                target={"_blank"}
                rel="noreferrer"
                className={`cursor-pointer w-fit flex items-center gap-5 lg:text-xl text-lg font-medium text-gray-900  lg:mt-[60px] sm:mt-12 mt-7`}
              >
                {linkText}
                <svg
                  className={`${animationClass}`}
                  width="13"
                  height="30"
                  viewBox="0 0 13 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.18502 19.7224L7.18594 19.7215L12.2182 14.7758C12.5952 14.4053 12.5938 13.806 12.2149 13.4372C11.8361 13.0684 11.2234 13.0698 10.8463 13.4404L7.46774 16.7609L7.46774 0.946514C7.46774 0.423754 7.03448 0 6.5 0C5.96552 0 5.53226 0.423754 5.53226 0.946514L5.53226 16.7609L2.15368 13.4404C1.77664 13.0699 1.16392 13.0685 0.785093 13.4372C0.406174 13.806 0.404867 14.4054 0.781803 14.7758L5.81406 19.7216L5.81498 19.7224C6.19327 20.0931 6.80798 20.0919 7.18502 19.7224Z"
                    fill="#212529"
                  />
                </svg>
              </a>
            ) : (
              <Link
                to={link}
                target={isAnotherPage ? "_blank" : ""}
                className={`cursor-pointer w-fit flex items-center gap-5 lg:text-xl text-lg font-medium text-gray-900  lg:mt-[60px] sm:mt-12 mt-7 ${isIndexPage ? "hidden" : ""
                  }`}
              >
                {linkText}
                <svg
                  className={`${animationClass}`}
                  width="13"
                  height="30"
                  viewBox="0 0 13 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.18502 19.7224L7.18594 19.7215L12.2182 14.7758C12.5952 14.4053 12.5938 13.806 12.2149 13.4372C11.8361 13.0684 11.2234 13.0698 10.8463 13.4404L7.46774 16.7609L7.46774 0.946514C7.46774 0.423754 7.03448 0 6.5 0C5.96552 0 5.53226 0.423754 5.53226 0.946514L5.53226 16.7609L2.15368 13.4404C1.77664 13.0699 1.16392 13.0685 0.785093 13.4372C0.406174 13.806 0.404867 14.4054 0.781803 14.7758L5.81406 19.7216L5.81498 19.7224C6.19327 20.0931 6.80798 20.0919 7.18502 19.7224Z"
                    fill="#212529"
                  />
                </svg>
              </Link>
            )}
          </div>
        </div>
      </div>

      <picture>
        <source srcSet={bannerBgWebp} type="image/webp" />
        <source srcSet={bannerBg} type="image/png" />
        <img
          src={bannerBg}
          alt="banner-bg"
          className="absolute left-0 right-0 top-0 bottom-0 m-auto z-[-1] lg:w-[990px] sm:w-[800px] w-[500px] lg:h-[990px] sm:h-[800px] h-[500px] object-cover sm:block hidden"
        />
      </picture>
    </div>
  );
};

export default Banner;
